import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type TradeInModuleSpecsFragment } from '../../../../api/fragments/TradeInModuleSpecs';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

type Props = {
    module: TradeInModuleSpecsFragment;
};

const TradeInModuleUpdateForm = ({ module }: Props) => {
    const { t } = useTranslation(['moduleDetails']);

    return (
        <StyledContainer gutter={10}>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.displayName', {
                        returnObjects: true,
                    })}
                    name="displayName"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.tradeInAppBaseUrl', {
                        returnObjects: true,
                    })}
                    name="setting.baseUrl"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.tradeInAppClientId', {
                        returnObjects: true,
                    })}
                    name="setting.clientId"
                    required
                />
            </Col>

            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.tradeInAppClientSecret', {
                        returnObjects: true,
                    })}
                    name="setting.clientSecret"
                    required
                />
            </Col>
        </StyledContainer>
    );
};

export default TradeInModuleUpdateForm;
